export const createCompareByProperty = (property, direction = "asc") => (a, b) => {
  const asc = direction === "asc";
  const aProp = asc ? a[property] : b[property];
  const bProp = asc ? b[property] : a[property];
  switch (typeof aProp) {
    case "string":
      return aProp.localeCompare(bProp);
    case "number":
    default:
      return aProp - bProp;
  }
};

export const compareByOrderProperty = createCompareByProperty("order");
